/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationEmailDeliveriesControllerEmailPreview } from "./notificationEmailDeliveriesControllerEmailPreview";
import { notificationEmailDeliveriesControllerFindAll } from "./notificationEmailDeliveriesControllerFindAll";
import { notificationEmailDeliveriesControllerFindOne } from "./notificationEmailDeliveriesControllerFindOne";
import { notificationEmailDeliveryFlushesControllerCreate } from "./notificationEmailDeliveryFlushesControllerCreate";
import { notificationEmailDeliveryReplaysControllerCreate } from "./notificationEmailDeliveryReplaysControllerCreate";

export function notificationEmailDeliveriesService() {
  return { notificationEmailDeliveriesControllerFindAll, notificationEmailDeliveriesControllerFindOne, notificationEmailDeliveriesControllerEmailPreview, notificationEmailDeliveryReplaysControllerCreate, notificationEmailDeliveryFlushesControllerCreate }
}